import { motion } from "framer-motion";
import { ScanLine } from "lucide-react";

const APPS = [
  { key: "swiggy", name: "Swiggy", tagline: "Order in minutes", accent: "#FC8019", img: "/qr-swiggy.png" },
  { key: "zomato", name: "Zomato", tagline: "Doorstep delivery", accent: "#E23744", img: "/qr-zomato.png" },
  { key: "ownly", name: "Ownly", tagline: "Home-cooked, direct", accent: "#7a1f1f", img: "/qr-ownly.png" },
];

export default function OrderApps() {
  return (
    <section id="order" className="relative bg-[#2b1414] text-[#f7f0e0] py-20 md:py-24 overflow-hidden">
      <div className="mx-auto max-w-6xl px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-12"
        >
          <div className="inline-flex items-center gap-3 mb-4">
            <ScanLine size={20} className="text-[#d97706]" />
            <p className="text-sm uppercase tracking-[0.3em] font-bold text-[#d97706]">Order Online — We&apos;re Live</p>
          </div>
          <h2 className="font-display text-5xl md:text-6xl font-bold tracking-tight leading-none">
            Scan &amp; <span className="italic font-accent text-[#d97706]">Order</span> from your favourite app
          </h2>
          <p className="mt-5 max-w-xl mx-auto text-[#f7f0e0]/80 leading-relaxed">
            Puneri Kitchen is live on Swiggy, Zomato and Ownly. Point your phone
            camera at any QR below — your app opens instantly.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {APPS.map((a, i) => (
            <motion.div
              key={a.key}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="group rounded-3xl bg-[#f7f0e0] p-5 md:p-6 text-[#331818] ring-1 ring-[#f7f0e0]/10 shadow-[0_20px_60px_rgba(0,0,0,0.25)] transition-transform duration-300 hover:-translate-y-1"
              data-testid={`order-card-${a.key}`}
            >
              <div className="flex items-center justify-between mb-4">
                <span
                  className="text-xs font-bold uppercase tracking-[0.22em] px-3 py-1.5 rounded-full text-[#f7f0e0]"
                  style={{ backgroundColor: a.accent }}
                >
                  {a.name}
                </span>
                <span className="text-xs text-[#5c3a3a]">{a.tagline}</span>
              </div>
              <div className="rounded-2xl overflow-hidden bg-white ring-1 ring-[#7a1f1f]/10">
                <img
                  src={a.img}
                  alt={`Scan to order Puneri Kitchen on ${a.name}`}
                  data-testid={`order-qr-${a.key}`}
                  className="w-full h-auto block"
                  loading="lazy"
                />
              </div>
              <p className="mt-4 text-center text-sm font-medium text-[#5c3a3a]">
                Scan with your camera to open {a.name}
              </p>
            </motion.div>
          ))}
        </div>

        <p className="mt-10 text-center text-sm text-[#f7f0e0]/60">
          Prefer to talk? Call or WhatsApp us at
          <a href="https://wa.me/917022919654" className="ml-1 font-semibold text-[#d97706] hover:underline" data-testid="order-whatsapp">+91 7022919654</a>.
        </p>
      </div>
    </section>
  );
}
